import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/resignation-letter-generator/ResignationLetterContent.tsx");
